import axios from 'axios';
import { setAuthHeader, removeAuthHeader } from './common';
import { BASE_API_URL } from 'utils/constants';
import { toast } from 'react-toastify';

export const get = async (url: string, params?: object, shouldSetAuthHeader = true, shouldRemoveAuthHeader = false) => {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }

  return await axios.get('/' + url, {
    baseURL: BASE_API_URL,
    params: {
      ...params,
    },
  });
};
export const deleted = async (
  url: string,
  // params : string,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) => {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  return await axios.delete(BASE_API_URL + '/' + url);
};

export const downloadFile = async (
  url: string,
  // params : string,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) => {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  await axios({
    url: BASE_API_URL + '/' + url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const fileName = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim();
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
};
export async function downloadFilePost<T = unknown>(
  url: string,
  params: T,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  await axios({
    url: BASE_API_URL + '/' + url,
    method: 'POST',
    responseType: 'blob',
    data: params,
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const fileName = response.headers['content-disposition'].split(';')[1].replace('filename=', '').trim();
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch((e) => {
      if (e.response) {
        if (e.response.status !== 200) {
          toast.error('Status: ' + e.response.status + '\n' + e.response.data.message);
        }
        return e;
      }
    });
}

export async function post<T = unknown>(
  url: string,
  params: T,
  apiLink = BASE_API_URL,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  // axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
  return await axios.post(apiLink + '/' + url, params).catch((e) => {
    console.log(e);
    if (e.response) {
      if (e.response.status !== 200) {
        toast.error('Status: ' + e.response.status + '\n' + e.response.data.message);
      }
      return e.response;
    }
  });
}

export async function put<T = unknown>(
  url: string,
  params: T,
  shouldSetAuthHeader = true,
  shouldRemoveAuthHeader = false,
) {
  if (shouldSetAuthHeader) {
    setAuthHeader();
  }
  if (shouldRemoveAuthHeader) {
    removeAuthHeader();
  }
  return await axios
    .put(BASE_API_URL + '/' + url, params)

    .catch((e) => {
      if (e.response) {
        if (e.response.status !== 200) {
          // toast.error('Status: ' + e.response.status + '\n' + e.response.data.message);
          toast.error(e.response.data.message);
        }
        return e.response;
      }
    });
}
